// extracted by mini-css-extract-plugin
module.exports = {"content":"CookieConsentDialog_content__kL5OB"};